export enum SoftphoneMessageEventEnum {
  ConfirmEvent = 'confirm_event',
  DestroyWorker = 'destroy_worker',
  NotFound = 'not_found',
  SendEvent = 'send_event',
  StartListener = 'start_listener',
  UpdateContact = 'update_contact',
}
